module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAGnRFWHRTb2Z0d2FyZQBQYWludC5ORVQgdjMuNS4xMDD0cqEAAABZSURBVDhPzcwxDsAwCAPA/P/TrUJuiRSKqDr0RmMzPncV1M50Sup99kHUZ78/kAVRSu3dA5XNOUw4b1oPJpUgWmSP40ktiBZZ+SBlH0R99iX1M52U2m+McQNNe0bIGx1lkQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// E:/Atlassian/bamboo-home/1/7766019/ESDE-EN172-JOB1/ng5/node_modules/jqwidgets-framework/jqwidgets/styles/images/icon-recurrence-white.png
// module id = ../../../../jqwidgets-framework/jqwidgets/styles/images/icon-recurrence-white.png
// module chunks = styles